import React from 'react';
import UserIcon from 'assets/images/icons/user.svg';

const getNameInitial = name => {
  if (!name) return '';
  if (name.length < 3) return name.toUpperCase();
  const [fname, lname] = name.split(' ');
  if (!lname) return fname[0].toUpperCase();
  return `${fname[0]}${lname[0]}`.toUpperCase();
};

const AvatarImg = ({ picture, name, showNoImageIcon, width, height, className, size = 'sm' }) => {
  const showInitial = !showNoImageIcon && (!picture || picture === 'null' || picture === 'undefined');

  const nameInitial = getNameInitial(name);
  return (
    <div
      className={`avatar-img ${showInitial ? 'border no-avatar-image' : ''} size-${size} rounded-100p ${className ||
        ''}`}
      style={{ width, height }}
    >
      {!showInitial && (
        <img className={`rounded-100p`} width={width} height={height} src={picture || UserIcon} alt='avatar' />
      )}
      {showInitial && nameInitial && <span>{nameInitial}</span>}
    </div>
  );
};

export default AvatarImg;
